import { render, staticRenderFns } from "./Registre.vue?vue&type=template&id=0ccef7b2&scoped=true"
import script from "./Registre.vue?vue&type=script&lang=js"
export * from "./Registre.vue?vue&type=script&lang=js"
import style0 from "./Registre.vue?vue&type=style&index=0&id=0ccef7b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccef7b2",
  null
  
)

export default component.exports